/**
 * Collection Compressed View Handler
 * Show More / Show Less on product cards when compressed view is enabled.
 *
 * Show More is one switch for the whole page: it expands or collapses EVERY card together. The page remembers which
 * state it is in (window.scShowAll), so cards that arrive later (Load more, the Notes filter) can be put in the same
 * state with window.scSyncShowMore(). Before, the new cards always arrived collapsed, so after an expand-all and a
 * Load more the page held a mix, and the next click flipped both groups the wrong way round.
 */
(function() {
  'use strict';

  // Only initialize if function doesn't already exist
  if (typeof window.handleShowMore !== 'undefined') {
    return;
  }

  window.scShowAll = false;

  /** Puts every product card (or the ones inside root) in the page's current state. */
  window.scSyncShowMore = function(root) {
    try {
      (root || document).querySelectorAll('.product-container').forEach(function(container) {
        container.classList.toggle('show-more', window.scShowAll);
      });
    } catch (error) {
      console.error('Collection Compressed View: Error syncing product containers', error);
    }
  };

  /**
   * Flips the page between collapsed and expanded and puts every card in the new state.
   * @param {HTMLElement} triggerElement - the element that was clicked (unused, kept for compatibility)
   */
  window.handleShowMore = function(triggerElement) {
    try {
      if (!document.querySelector('.product-container')) {
        console.warn('Collection Compressed View: No product containers found');
        return;
      }
      window.scShowAll = !window.scShowAll;
      window.scSyncShowMore();
    } catch (error) {
      console.error('Collection Compressed View: Error toggling product containers', error);
    }
  };
})();
